import dayjs from 'dayjs';

export function getExactDate(selectedDay: number, today: number) {
  return selectedDay === today
    ? '今天'
    : dayjs()
        .subtract(today - selectedDay, 'days')
        .format('MM/DD');
}
